(() => {
  const initWalltraudZubehoerLandingpage = () => {
    const heroButton = document.querySelector('.wt-zubehoer-section [data-wt-zubehoer-hero-cta]');
    const products = document.getElementById('wt-zubehoer-products');
    const sticky = document.querySelector('.wt-zubehoer-section [data-wt-zubehoer-sticky]');

    if (sticky && sticky.dataset.wtZubehoerInitialized !== 'true') {
      sticky.dataset.wtZubehoerInitialized = 'true';

      if (heroButton && products && 'IntersectionObserver' in window) {
        let heroVisible = true;
        let productsVisible = false;

        const updateSticky = () => {
          const show = !heroVisible && !productsVisible;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        };

        const heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0 });

        const productObserver = new IntersectionObserver((entries) => {
          productsVisible = entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0.06 });

        heroObserver.observe(heroButton);
        productObserver.observe(products);
      }
    }

    document.querySelectorAll('.wt-zubehoer-section a[href^="#"]').forEach((link) => {
      if (link.dataset.wtZubehoerSmooth === 'true') return;
      link.dataset.wtZubehoerSmooth = 'true';

      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || selector === '#') return;

        const target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWalltraudZubehoerLandingpage);
  } else {
    initWalltraudZubehoerLandingpage();
  }

  document.addEventListener('shopify:section:load', initWalltraudZubehoerLandingpage);
})();
